import i18n from "./i18n";

const loaded = new Set();

export async function loadProductionLocale(locale) {
  if (loaded.has(locale)) {
    i18n.locale = locale;
    return;
  }

  const messages = await import(`./dist/${locale}.json`);
  i18n.setLocaleMessage(locale, messages.default);
  loaded.add(locale);
  i18n.locale = locale;
  document.documentElement.lang = locale;
  return locale;
}
